import React from "react";
import { Youtube, Facebook } from "lucide-react";

/**
 * Foundation of Light — official social channels.
 *
 * These same URLs are referenced in the Organization JSON-LD `sameAs` field
 * on the homepage, which is what Google reads to build the Knowledge Panel.
 * Keep them in sync if you ever change a handle.
 */
export const SOCIAL_LINKS = [
    {
        name: "Facebook",
        url: "https://www.facebook.com/profile.php?id=61594037591876",
        icon: (props) => <Facebook {...props} />,
        label: "Page Facebook Foundation of Light",
    },
    {
        name: "YouTube",
        url: "https://www.youtube.com/channel/UCmu2akD8eUBRIeD5d-Vmwfg",
        icon: (props) => <Youtube {...props} />,
        label: "Chaîne YouTube Foundation of Light",
    },
    {
        name: "TikTok",
        url: "https://www.tiktok.com/@foundation.of.light",
        // Custom inline SVG — TikTok is not part of lucide-react.
        icon: (props) => (
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
                <path d="M19.32 6.86a5.6 5.6 0 0 1-3.29-1.05 5.62 5.62 0 0 1-2.24-4.48V1h-3.2v13.14a2.75 2.75 0 0 1-2.75 2.75 2.75 2.75 0 0 1-2.75-2.75 2.75 2.75 0 0 1 4-2.44V8.42a5.95 5.95 0 0 0-6.99 5.87 5.94 5.94 0 0 0 5.94 5.94 5.94 5.94 0 0 0 5.94-5.94V8.9a8.72 8.72 0 0 0 5.29 1.78V7.48a5.5 5.5 0 0 1-.05-.62z" />
            </svg>
        ),
        label: "Chaîne TikTok Foundation of Light",
    },
];

/**
 * Compact horizontal row of social icons. Sizes:
 *   - `md` (default) : 20px icons, 40px hitbox — footer, hero
 *   - `sm`           : 16px icons, 32px hitbox — inline in text
 *   - `lg`           : 24px icons, 48px hitbox — dedicated CTA
 */
export default function SocialLinks({ size = "md", className = "", testid = "social-links" }) {
    const dim = size === "sm"
        ? { hit: "w-8 h-8", icon: "w-4 h-4" }
        : size === "lg"
            ? { hit: "w-12 h-12", icon: "w-6 h-6" }
            : { hit: "w-10 h-10", icon: "w-5 h-5" };
    return (
        <div className={`flex items-center gap-2 ${className}`} data-testid={testid}>
            {SOCIAL_LINKS.map((s) => (
                <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={s.label}
                    className={`inline-flex items-center justify-center rounded-full border border-border/60 bg-background/60 text-foreground/70 hover:text-primary hover:border-primary/50 hover:bg-primary/5 transition-colors ${dim.hit}`}
                    data-testid={`social-${s.name.toLowerCase()}`}
                >
                    <s.icon className={dim.icon} />
                </a>
            ))}
        </div>
    );
}
